module.exports = __webpack_public_path__ + "img/9788949120768.574a09df.jpg";